import React, { useEffect, useRef } from 'react';

export function scrollBy(node, offset) {
    node.scrollTo({
        top: 0,
        left: node.scrollLeft + offset,
        behavior: 'smooth'
    });
}

function handleIntersection(node, toggle) {
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            toggle(prev => {
                if (entry.isIntersecting) {
                    if (prev === true) {
                        return false;
                    }
                } else {
                    if (prev === false) {
                        return true;
                    }
                }

                return prev;
            });
        });
    });
    observer.observe(node);

    return observer;
}

export function ScrollerSpy(props) {
    const ref = useRef(null);
    useEffect(() => {
        let observer = null;
        const node = ref.current;
        if (node != null) {
            observer = handleIntersection(node, props.toggle);
        }
        return () => observer?.disconnect();
    }, []);

    return (
        <xs-spy ref={ref}></xs-spy>
    );
}
